import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENGAGEMENT_API_TOKEN } from '@epicuro-next/data/engagement/engagement-models';
import { map } from 'rxjs/internal/operators/map';

import { StoryDto } from '../interfaces';

@Injectable()
export class StoriesApiService {
  constructor(
    private http: HttpClient,
    @Inject(ENGAGEMENT_API_TOKEN) private apiUrl: string,
  ) {}

  public getStory(id: string) {
    return this.http
      .get<StoryDto>(`${this.apiUrl}/story/${id}`)
      .pipe(map((response) => response.story));
  }
}
